import { selectPlanExclusions, useAppInitStore } from '../../stores';

export const usePlanExclusions = () => {
	const planExclusions = useAppInitStore(selectPlanExclusions);

	return { planExclusions };
};
